__turbopack_context__.v({
  "desktop-onboarding-flow-container": "OnboardingFlowContainers-module-scss-module__AyRvUW__desktop-onboarding-flow-container",
  "mobile-onboarding-flow-container": "OnboardingFlowContainers-module-scss-module__AyRvUW__mobile-onboarding-flow-container",
});
